import {Component, input, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'app-lib-bar',
  templateUrl: './bar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './bar.component.css'
})
export class BarComponent {

  mode = input<'blend'|'standout'>('standout');
  customClass = input<string>('');

}
